module.exports = __webpack_public_path__ + "static/educacional-3bf63e6c1ac6013cfe124125a06526e0.jpg";